import { CuboidPartsArrays } from '@App/app/entities/layer/cuboid.model';
import {
  CUBOID_PART,
  CUBOID_PART_STRICT,
  LAYER_TYPES,
} from '@App/app/entities/layer/enums/layer-types.enum';
import { inject, Injectable } from '@angular/core';
import { Mesh } from 'babylonjs';
import { UtilsService } from '../../../utils-service/utils.service';
import { RectangleToolsGeometryService } from '../shared/rectangle-tools-geometry.service';
import { RectangleToolsService } from '../shared/rectangle-tools-service';

@Injectable({
  providedIn: 'root',
})
export class CuboidService extends RectangleToolsService {
  activePart: CUBOID_PART = CUBOID_PART.NONE;
  highlightedSample: { part: CUBOID_PART; i: number } = {
    part: CUBOID_PART.NONE,
    i: -1,
  };
  samples: CuboidPartsArrays<Mesh> = { 1: [], 2: [], 3: [] };

  private utilsService = inject(UtilsService);
  private geometryService = inject(RectangleToolsGeometryService);

  generateCuboidBoundingBox() {
    try {
      const result = this.geometryService.calculateSidesData(
        this.samples[CUBOID_PART.FRONT_BACK],
        this.samples[CUBOID_PART.LEFT_RIGHT],
        this.samples[CUBOID_PART.TOP_BOTTOM],
      );
      this.save({
        type: LAYER_TYPES.CUBOID,
        topPlaneNormal: result.topPlaneNormal,
        surfacePlaneNormal: result.originalSurfacePlaneNormal,
        center: result.centerPosition,
        width: result.adjacentSurfaceLength,
        depth: result.originalSurfaceLength,
        height: result.topBottomSurfaceLength,
        sampleMeshes: this.samples[CUBOID_PART.FRONT_BACK],
      });
      this.clearSamples();
    } catch (err) {
      this.clearSamples();
      this.utilsService.catchToolCreationError(err);
    }
  }

  // eslint-disable-next-line complexity
  setActivePart(part: CUBOID_PART) {
    const isConflictingPart =
      (part === CUBOID_PART.LEFT_RIGHT && this.samples[CUBOID_PART.TOP_BOTTOM].length) ||
      (part === CUBOID_PART.TOP_BOTTOM && this.samples[CUBOID_PART.LEFT_RIGHT].length);
    if (!isConflictingPart) {
      this.activePart = this.activePart === part ? CUBOID_PART.NONE : part;
      this._dataChange$.next();
    }
  }
}
